import { styled } from "@mui/material/styles";

// Components
import { Menu, MenuItem } from "@mui/material";

// Themes
import theme from "../Theme";

const styledName = "OptionMenu";

export const StyledMenu = styled(Menu, { name: styledName })({
  ".MuiPaper-root": {
    borderRadius: "10px",
  },
});

export const StyledMenuItem = styled(MenuItem, { name: styledName })({
  "&": {
    ":hover": {
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
    },
  },
});
